import { Link, useLocation } from "react-router-dom";
import {
  MdDeleteForever,
  MdOutlineSpaceDashboard,
  MdOutlineBusinessCenter,
  MdNotificationsNone,
  MdConnectWithoutContact,
  MdOutlineEmail,
  MdOutlineForum,
  MdSmartToy,
  MdCloudUpload,
  MdKeyboardArrowDown,
  MdKeyboardArrowRight,
  MdOutlinePeopleAlt,
  MdOutlinePayments,
  MdOutlineCampaign,
  MdOutlineAdminPanelSettings,
  MdOutlineSubscriptions,
  MdOutlineSupportAgent,
  MdAutoAwesome,
  MdOutlineEditNotifications,
} from "react-icons/md";

import {
  PiUserSquare,
  PiFlagBannerFoldDuotone,
  PiContactlessPayment,
  PiMonitorPlayDuotone,
} from "react-icons/pi";

import { RiArchiveDrawerLine } from "react-icons/ri";

import { TbUserCheck, TbBusinessplan } from "react-icons/tb";

import Logo from "../../assets/Images/logo.png";

import { MENU } from "../../assets/constants/constants";

import { useEffect, useState } from "react";

import { BiDollar, BiPurchaseTag } from "react-icons/bi";
import { FaBlog, FaBullhorn, FaChartLine, FaComment, FaCreativeCommonsSampling, FaUserTie } from "react-icons/fa";

interface Props {
  collapsed: boolean;
  toggleSidebar: () => void;
}

const VerticalMenu = ({ collapsed, toggleSidebar }: Props) => {
  const URL = useLocation();

  const [active_menu, setActiveMenu] = useState(
    localStorage.getItem("active_menu") ?? MENU.DASHBOARD,
  );
  const [chatbotOpen, setChatbotOpen] = useState<boolean>(false);
  const [profilesOpen, setProfilesOpen] = useState<boolean>(true);
  const [paymentsOpen, setPaymentsOpen] = useState<boolean>(false);
  const [promotionsOpen, setPromotionsOpen] = useState<boolean>(false);
  const [adminUsersOpen, setAdminUsersOpen] = useState<boolean>(false);
  const [subscriptionsOpen, setSubscriptionsOpen] = useState<boolean>(false);
  const [contactSupportOpen, setContactSupportOpen] = useState<boolean>(false);
  const [notificationLogsOpen, setNotificationLogsOpen] = useState<boolean>(false);

  const PATH_TO_MENU: any = {
    "/dashboard": MENU.DASHBOARD,
    "/manage-entrepreneur": MENU.MANAGE_ENTERPRENEUR,
    "/manage-investor": MENU.MANAGE_INVESTOR,
    "/manage-mentors": MENU.MANAGE_MENTOR,
    "/mentor-payments": MENU.MENTOR_PAYMENTS,
    "/mentor-payouts": MENU.MENTOR_PAYOUTS,
    "/manage-subscription": MENU.MANAGE_SUBSCRIPTION,
    "/manage-banners": MENU.MANAGE_BANNER,
    "/manage-promotions": MENU.MANAGE_PROMOTION,
    "/personalized-notifications": MENU.MANAGE_PERSONALIZED_NOTIFICATION,
    "/manage-forum-post": MENU.INVESTOR_FORUM_POST,
    "/manage-network-forum": MENU.MANAGE_NETWORK_FORUM,
    "/manage-network-hub": MENU.MANAGE_NETWORK_FORUM,
    "/manage-roles": MENU.MANAGE_ROLE,
    "/manage-users": MENU.MANAGE_USER,
    "/manage-transaction": MENU.MANAGE_TRANSACTION,
    "/manage-active-subscription": MENU.MANAGE_ACTIVE_SUBSCRIPTION,
    "/manage-customer-queries": MENU.MANAGE_CUSTOMER_QUERIES,
    "/manage-deactivated-accounts": MENU.MANAGE_DEACTIVATED_ACCOUNTS,
    "/manage-coupons": MENU.MANAGE_COUPONS,
    "/email-management": MENU.MANAGE_EMAIL,
    "/manage-chatbot-sessions": MENU.MANAGE_SESSIONS,
    "/update-knowledge-base": MENU.UPDATE_KNOWLEDGE_BASE,
    "/notification-logs": MENU.AI_NOTIFICATION_LOGS,
    "/ai-notification-logs": MENU.AI_NOTIFICATION_LOGS,
    "/manual-notifications": MENU.MANUAL_NOTIFICATION_LOGS,
  };

  const handleMenuClick = (menu: string) => {
    setActiveMenu(menu);

    localStorage.setItem("active_menu", menu);

    if (menu === MENU.MANAGE_ENTERPRENEUR || menu === MENU.MANAGE_INVESTOR) {
      localStorage.setItem("selectedTab", "request");
    }
  };

  useEffect(() => {
    const matchedMenu = PATH_TO_MENU[URL.pathname] || (URL.pathname.startsWith("/view-network-forum") || URL.pathname.startsWith("/view-network-hub") ? MENU.MANAGE_NETWORK_FORUM : undefined);

    if (matchedMenu) {
      setActiveMenu(matchedMenu);

      localStorage.setItem("active_menu", matchedMenu);
      if (
        matchedMenu === MENU.MANAGE_SESSIONS ||
        matchedMenu === MENU.UPDATE_KNOWLEDGE_BASE
      ) {
        setChatbotOpen(true);
      }
      if (
        matchedMenu === MENU.MANAGE_ENTERPRENEUR ||
        matchedMenu === MENU.MANAGE_INVESTOR ||
        matchedMenu === MENU.MANAGE_MENTOR ||
        matchedMenu === MENU.MANAGE_DEACTIVATED_ACCOUNTS
      ) {
        setProfilesOpen(true);
      }
      if (
        matchedMenu === MENU.MENTOR_PAYMENTS ||
        matchedMenu === MENU.MENTOR_PAYOUTS ||
        matchedMenu === MENU.MANAGE_TRANSACTION
      ) {
        setPaymentsOpen(true);
      }
      if (
        matchedMenu === MENU.MANAGE_COUPONS ||
        matchedMenu === MENU.MANAGE_BANNER ||
        matchedMenu === MENU.MANAGE_PROMOTION ||
        matchedMenu === MENU.MANAGE_PERSONALIZED_NOTIFICATION ||
        matchedMenu === MENU.INVESTOR_FORUM_POST
      ) {
        setPromotionsOpen(true);
      }
      if (
        matchedMenu === MENU.MANAGE_ROLE ||
        matchedMenu === MENU.MANAGE_USER
      ) {
        setAdminUsersOpen(true);
      }
      if (
        matchedMenu === MENU.MANAGE_SUBSCRIPTION ||
        matchedMenu === MENU.MANAGE_ACTIVE_SUBSCRIPTION
      ) {
        setSubscriptionsOpen(true);
      }
      if (
        matchedMenu === MENU.MANAGE_EMAIL ||
        matchedMenu === MENU.MANAGE_CUSTOMER_QUERIES
      ) {
        setContactSupportOpen(true);
      }
      if (
        matchedMenu === MENU.NOTIFICATION_LOGS ||
        matchedMenu === MENU.AI_NOTIFICATION_LOGS ||
        matchedMenu === MENU.MANUAL_NOTIFICATION_LOGS
      ) {
        setNotificationLogsOpen(true);
      }
    }
  }, [URL.pathname]);

  return (
    <div
      id="vertical_menu"
      className={`verticle-menu ${collapsed ? "collapsed-menu" : ""}`}
    >
      {/* Logo */}
      <div className="text-center pb-3 position-relative">
        <img
          src={Logo}
          width={collapsed ? 55 : 118}
          alt=""
          className="transition-all"
        />
      </div>

      <div className="menu-list">
        {/* Dashboard */}
        <Link
          to={"/dashboard"}
          title="Dashboard"
          className={
            active_menu === MENU.DASHBOARD ? "active menu-item" : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.DASHBOARD)}
        >
          <MdOutlineSpaceDashboard className="menu-icon" />

          {!collapsed && <span className="nav-text">Dashboard</span>}
        </Link>

        {/* Network Hub */}


        {/* Manage Profiles Group */}
        <div className="menu-group">
          <div
            className={`menu-item menu-parent ${active_menu === MENU.MANAGE_ENTERPRENEUR ||
              active_menu === MENU.MANAGE_INVESTOR ||
              active_menu === MENU.MANAGE_MENTOR ||
              active_menu === MENU.MANAGE_DEACTIVATED_ACCOUNTS
              ? "active"
              : ""
              }`}
            onClick={() => setProfilesOpen(!profilesOpen)}
            style={{ cursor: "pointer", justifyContent: "space-between" }}
            title="Manage Profiles"
          >
            <div className="d-flex align-items-center gap-2">
              <MdOutlinePeopleAlt className="menu-icon" />
              {!collapsed && <span className="nav-text">Manage Profiles</span>}
            </div>
            {!collapsed &&
              (profilesOpen ? (
                <MdKeyboardArrowDown size={18} />
              ) : (
                <MdKeyboardArrowRight size={18} />
              ))}
          </div>

          {(profilesOpen || collapsed) && (
            <div className={`submenu-list ${!collapsed ? "ps-3" : ""}`}>
              {/* Entrepreneur */}
              <Link
                to={"/manage-entrepreneur"}
                title="Manage Entrepreneur"
                className={
                  active_menu === MENU.MANAGE_ENTERPRENEUR
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_ENTERPRENEUR)}
              >
                <MdOutlineBusinessCenter className="menu-icon" />

                {!collapsed && (
                  <span className="nav-text">Manage Entrepreneur</span>
                )}
              </Link>

              {/* Investor */}
              <Link
                to={"/manage-investor"}
                title="Manage Investors"
                className={
                  active_menu === MENU.MANAGE_INVESTOR
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_INVESTOR)}
              >
                <TbBusinessplan className="menu-icon" />

                {!collapsed && (
                  <span className="nav-text">Manage Investors</span>
                )}
              </Link>

              {/* Mentor */}
              <Link
                id="t-4"
                to={"/manage-mentors"}
                title="Manage Mentors"
                className={
                  active_menu === MENU.MANAGE_MENTOR
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_MENTOR)}
              >
                <FaUserTie className="menu-icon" />

                {!collapsed && (
                  <span className="nav-text">Manage Mentors</span>
                )}
              </Link>

              {/* Deleted Accounts */}
              <Link
                to={"/manage-deactivated-accounts"}
                title="Manage Deleted Accounts"
                className={
                  active_menu === MENU.MANAGE_DEACTIVATED_ACCOUNTS
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_DEACTIVATED_ACCOUNTS)}
              >
                <MdDeleteForever className="menu-icon" />

                {!collapsed && (
                  <span className="nav-text">Manage Deleted Accounts</span>
                )}
              </Link>
            </div>
          )}
        </div>
        {/* Contact & Support Group */}


        {/* Subscriptions Group */}
        <div className="menu-group">
          <div
            className={`menu-item menu-parent ${active_menu === MENU.MANAGE_SUBSCRIPTION ||
              active_menu === MENU.MANAGE_ACTIVE_SUBSCRIPTION
              ? "active"
              : ""
              }`}
            onClick={() => setSubscriptionsOpen(!subscriptionsOpen)}
            style={{ cursor: "pointer", justifyContent: "space-between" }}
            title="Subscriptions"
          >
            <div className="d-flex align-items-center gap-2">
              <MdOutlineSubscriptions className="menu-icon" />
              {!collapsed && <span className="nav-text">Subscriptions</span>}
            </div>
            {!collapsed &&
              (subscriptionsOpen ? (
                <MdKeyboardArrowDown size={18} />
              ) : (
                <MdKeyboardArrowRight size={18} />
              ))}
          </div>

          {(subscriptionsOpen || collapsed) && (
            <div className={`submenu-list ${!collapsed ? "ps-3" : ""}`}>
              {/* Manage Subscriptions */}
              <Link
                to={"/manage-subscription"}
                title="Manage Subscriptions"
                className={
                  active_menu === MENU.MANAGE_SUBSCRIPTION
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_SUBSCRIPTION)}
              >
                <RiArchiveDrawerLine className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Manage Subscriptions</span>
                )}
              </Link>

              {/* Manage Active Subscription */}
              {/* <Link
                to={"/manage-active-subscription"}
                title="Manage Active Subscription"
                className={
                  active_menu === MENU.MANAGE_ACTIVE_SUBSCRIPTION
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_ACTIVE_SUBSCRIPTION)}
              >
                <BiPurchaseTag className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Manage Active Subscription</span>
                )}
              </Link> */}
            </div>
          )}
        </div>

        <Link
          to={"/manage-network-forum"}
          title="Network Hub"
          className={
            active_menu === MENU.MANAGE_NETWORK_FORUM
              ? "active menu-item"
              : "menu-item"
          }
          onClick={() => handleMenuClick(MENU.MANAGE_NETWORK_FORUM)}
        >
          <MdConnectWithoutContact className="menu-icon" />

          {!collapsed && (
            <span className="nav-text">Network Hub</span>
          )}
        </Link>
        {/* Promotions Group */}
        <div className="menu-group">
          <div
            className={`menu-item menu-parent ${active_menu === MENU.MANAGE_COUPONS ||
              active_menu === MENU.MANAGE_BANNER ||
              active_menu === MENU.MANAGE_PROMOTION ||
              active_menu === MENU.MANAGE_PERSONALIZED_NOTIFICATION ||
              active_menu === MENU.INVESTOR_FORUM_POST
              ? "active"
              : ""
              }`}
            onClick={() => setPromotionsOpen(!promotionsOpen)}
            style={{ cursor: "pointer", justifyContent: "space-between" }}
            title="Promotions"
          >
            <div className="d-flex align-items-center gap-2">
              <MdOutlineCampaign className="menu-icon" />
              {!collapsed && <span className="nav-text">Promotions</span>}
            </div>
            {!collapsed &&
              (promotionsOpen ? (
                <MdKeyboardArrowDown size={18} />
              ) : (
                <MdKeyboardArrowRight size={18} />
              ))}
          </div>

          {(promotionsOpen || collapsed) && (
            <div className={`submenu-list ${!collapsed ? "ps-3" : ""}`}>
              {/* Coupons */}
              <Link
                to={"/manage-coupons"}
                title="Manage Coupons"
                className={
                  active_menu === MENU.MANAGE_COUPONS
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_COUPONS)}
              >
                <BiDollar className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Manage Coupons</span>
                )}
              </Link>

              {/* Banner */}
              <Link
                to={"/manage-banners"}
                title="Manage Banners"
                className={
                  active_menu === MENU.MANAGE_BANNER
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_BANNER)}
              >
                <PiFlagBannerFoldDuotone className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Manage Banners</span>
                )}
              </Link>

              {/* Promotions */}
              <Link
                to={"/manage-promotions"}
                title="Manage Promotions"
                className={
                  active_menu === MENU.MANAGE_PROMOTION
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_PROMOTION)}
              >
                <PiMonitorPlayDuotone className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Manage Promotions</span>
                )}
              </Link>

              {/* Investor Forum Post */}
              <Link
                to={"/manage-forum-post"}
                title="Manage Investor Forum's Post"
                className={
                  active_menu === MENU.INVESTOR_FORUM_POST
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.INVESTOR_FORUM_POST)}
              >
                <FaBullhorn className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Manage Investor Forum's Post</span>
                )}
              </Link>

              {/* Personalized Notifications */}
              {/* <Link
                to={"/personalized-notifications"}
                title="Personalized Notifications"
                className={
                  active_menu === MENU.MANAGE_PERSONALIZED_NOTIFICATION
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_PERSONALIZED_NOTIFICATION)}
              >
                <MdNotificationsNone className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Personalized Notifications</span>
                )}
              </Link> */}
            </div>
          )}
        </div>

        {/* Admin Users Group */}
        <div className="menu-group">
          <div
            className={`menu-item menu-parent ${active_menu === MENU.MANAGE_ROLE ||
              active_menu === MENU.MANAGE_USER
              ? "active"
              : ""
              }`}
            onClick={() => setAdminUsersOpen(!adminUsersOpen)}
            style={{ cursor: "pointer", justifyContent: "space-between" }}
            title="Admin Users"
          >
            <div className="d-flex align-items-center gap-2">
              <MdOutlineAdminPanelSettings className="menu-icon" />
              {!collapsed && <span className="nav-text">Admin Users</span>}
            </div>
            {!collapsed &&
              (adminUsersOpen ? (
                <MdKeyboardArrowDown size={18} />
              ) : (
                <MdKeyboardArrowRight size={18} />
              ))}
          </div>

          {(adminUsersOpen || collapsed) && (
            <div className={`submenu-list ${!collapsed ? "ps-3" : ""}`}>
              {/* Roles */}
              <Link
                to={"/manage-roles"}
                title="Manage Role"
                className={
                  active_menu === MENU.MANAGE_ROLE ? "active menu-item" : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_ROLE)}
              >
                <PiUserSquare className="menu-icon" />
                {!collapsed && <span className="nav-text">Manage Role</span>}
              </Link>

              {/* Admin Users */}
              <Link
                to={"/manage-users"}
                title="Manage Admin Users"
                className={
                  active_menu === MENU.MANAGE_USER ? "active menu-item" : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_USER)}
              >
                <TbUserCheck className="menu-icon" />
                {!collapsed && <span className="nav-text">Manage Admin Users</span>}
              </Link>
            </div>
          )}
        </div>

        {/* Payments Group */}
        <div className="menu-group">
          <div
            className={`menu-item menu-parent ${active_menu === MENU.MENTOR_PAYMENTS ||
              active_menu === MENU.MENTOR_PAYOUTS ||
              active_menu === MENU.MANAGE_TRANSACTION
              ? "active"
              : ""
              }`}
            onClick={() => setPaymentsOpen(!paymentsOpen)}
            style={{ cursor: "pointer", justifyContent: "space-between" }}
            title="Payments"
          >
            <div className="d-flex align-items-center gap-2">
              <MdOutlinePayments className="menu-icon" />
              {!collapsed && <span className="nav-text">Payments</span>}
            </div>
            {!collapsed &&
              (paymentsOpen ? (
                <MdKeyboardArrowDown size={18} />
              ) : (
                <MdKeyboardArrowRight size={18} />
              ))}
          </div>

          {(paymentsOpen || collapsed) && (
            <div className={`submenu-list ${!collapsed ? "ps-3" : ""}`}>
              <Link
                id="t-4"
                to={"/mentor-payments"}
                title="Mentor Payments"
                className={
                  active_menu === MENU.MENTOR_PAYMENTS
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MENTOR_PAYMENTS)}
              >
                <PiContactlessPayment className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Mentor Payments</span>
                )}
              </Link>

              <Link
                id="t-4b"
                to={"/mentor-payouts"}
                title="Mentor Payouts"
                className={
                  active_menu === MENU.MENTOR_PAYOUTS
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MENTOR_PAYOUTS)}
              >
                <PiContactlessPayment className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Mentor Payouts</span>
                )}
              </Link>

              <Link
                to={"/manage-transaction"}
                title="Manage Transaction"
                className={
                  active_menu === MENU.MANAGE_TRANSACTION
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_TRANSACTION)}
              >
                <MdNotificationsNone className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Manage Transaction</span>
                )}
              </Link>
            </div>
          )}
        </div>

        {/* Notification Log Group */}
        <div className="menu-group">
          <div
            className={`menu-item menu-parent ${active_menu === MENU.NOTIFICATION_LOGS ||
              active_menu === MENU.AI_NOTIFICATION_LOGS ||
              active_menu === MENU.MANUAL_NOTIFICATION_LOGS
              ? "active"
              : ""
              }`}
            onClick={() => setNotificationLogsOpen(!notificationLogsOpen)}
            style={{ cursor: "pointer", justifyContent: "space-between" }}
            title="Notification Log"
          >
            <div className="d-flex align-items-center gap-2">
              <MdNotificationsNone className="menu-icon" />
              {!collapsed && <span className="nav-text">Notification Log</span>}
            </div>
            {!collapsed &&
              (notificationLogsOpen ? (
                <MdKeyboardArrowDown size={18} />
              ) : (
                <MdKeyboardArrowRight size={18} />
              ))}
          </div>

          {(notificationLogsOpen || collapsed) && (
            <div className={`submenu-list ${!collapsed ? "ps-3" : ""}`}>
              {/* Ai generated */}
              <Link
                to={"/notification-logs"}
                title="Ai generated"
                className={
                  active_menu === MENU.AI_NOTIFICATION_LOGS || active_menu === MENU.NOTIFICATION_LOGS
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.AI_NOTIFICATION_LOGS)}
              >
                <MdAutoAwesome className="menu-icon" />
                {!collapsed && <span className="nav-text">Ai generated</span>}
              </Link>

              {/* Manual */}
              <Link
                to={"/manual-notifications"}
                title="Manual"
                className={
                  active_menu === MENU.MANUAL_NOTIFICATION_LOGS
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANUAL_NOTIFICATION_LOGS)}
              >
                <MdOutlineEditNotifications className="menu-icon" />
                {!collapsed && <span className="nav-text">Manual</span>}
              </Link>
            </div>
          )}
        </div>
        {/* Chatbot Menu Group */}
        <div className="menu-group">
          <div
            className={`menu-item menu-parent ${active_menu === MENU.MANAGE_SESSIONS ||
              active_menu === MENU.UPDATE_KNOWLEDGE_BASE
              ? "active"
              : ""
              }`}
            onClick={() => setChatbotOpen(!chatbotOpen)}
            style={{ cursor: "pointer", justifyContent: "space-between" }}
            title="Chatbot"
          >
            <div className="d-flex align-items-center gap-2">
              <MdSmartToy className="menu-icon" />
              {!collapsed && <span className="nav-text">Chatbot</span>}
            </div>
            {!collapsed &&
              (chatbotOpen ? (
                <MdKeyboardArrowDown size={18} />
              ) : (
                <MdKeyboardArrowRight size={18} />
              ))}
          </div>

          {(chatbotOpen || collapsed) && (
            <div className={`submenu-list ${!collapsed ? "ps-3" : ""}`}>
              <Link
                to={"/manage-chatbot-sessions"}
                title="Manage Chatbot Sessions"
                className={
                  active_menu === MENU.MANAGE_SESSIONS
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_SESSIONS)}
              >
                <MdOutlineForum className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Manage Chatbot Sessions</span>
                )}
              </Link>

              <Link
                to={"/update-knowledge-base"}
                title="Update Knowledge Base"
                className={
                  active_menu === MENU.UPDATE_KNOWLEDGE_BASE
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.UPDATE_KNOWLEDGE_BASE)}
              >
                <MdCloudUpload className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Update Knowledge Base</span>
                )}
              </Link>
            </div>
          )}
        </div>
        <div className="menu-group">
          <div
            className={`menu-item menu-parent ${active_menu === MENU.MANAGE_EMAIL ||
              active_menu === MENU.MANAGE_CUSTOMER_QUERIES
              ? "active"
              : ""
              }`}
            onClick={() => setContactSupportOpen(!contactSupportOpen)}
            style={{ cursor: "pointer", justifyContent: "space-between" }}
            title="Contact & Support"
          >
            <div className="d-flex align-items-center gap-2">
              <MdOutlineSupportAgent className="menu-icon" />
              {!collapsed && <span className="nav-text">Contact & Support</span>}
            </div>
            {!collapsed &&
              (contactSupportOpen ? (
                <MdKeyboardArrowDown size={18} />
              ) : (
                <MdKeyboardArrowRight size={18} />
              ))}
          </div>

          {(contactSupportOpen || collapsed) && (
            <div className={`submenu-list ${!collapsed ? "ps-3" : ""}`}>
              {/* Email Management */}
              <Link
                to={"/email-management"}
                title="Email Management"
                className={
                  active_menu === MENU.MANAGE_EMAIL
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_EMAIL)}
              >
                <MdOutlineEmail className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Email Management</span>
                )}
              </Link>

              {/* Customer Queries */}
              <Link
                to={"/manage-customer-queries"}
                title="Manage Customer Queries"
                className={
                  active_menu === MENU.MANAGE_CUSTOMER_QUERIES
                    ? "active menu-item"
                    : "menu-item"
                }
                onClick={() => handleMenuClick(MENU.MANAGE_CUSTOMER_QUERIES)}
              >
                <MdConnectWithoutContact className="menu-icon" />
                {!collapsed && (
                  <span className="nav-text">Manage Customer Queries</span>
                )}
              </Link>
            </div>
          )}
        </div>


      </div>
    </div>
  );
};

export default VerticalMenu;
